import { render, staticRenderFns } from "./ExpandableMainNavContainer.vue?vue&type=template&id=b31d8cf0&"
import script from "./ExpandableMainNavContainer.vue?vue&type=script&lang=js&"
export * from "./ExpandableMainNavContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports